import { Entity, UniqueEntityID } from '@/domain/core'
import { WeightUnit } from '@/domain/protocols/Unit'

export interface DefaultWeightProps {
  name: string
  weight: number
  weightUnit: WeightUnit
  stationType: 'seat' | 'cargo'
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date
}

export interface DefaultWeightPojo extends DefaultWeightProps {
  id: string
}

export class DefaultWeight extends Entity<DefaultWeightProps, DefaultWeightPojo> {
  private constructor(props: DefaultWeightProps, id?: UniqueEntityID) {
    super(props, id)
  }

  public static create(props: DefaultWeightProps, id?: UniqueEntityID): DefaultWeight {
    const defaultWeight = new DefaultWeight(props, id)
    return defaultWeight
  }

  // Getters
  get name(): string {
    return this.props.name
  }

  get weight(): number {
    return this.props.weight
  }

  get weightUnit(): WeightUnit {
    return this.props.weightUnit
  }

  get stationType(): 'seat' | 'cargo' {
    return this.props.stationType
  }

  get createdAt(): Date {
    return this.props.createdAt
  }

  get updatedAt(): Date {
    return this.props.updatedAt
  }

  get deletedAt(): Date | undefined {
    return this.props.deletedAt
  }

  // Setters

  set name(name: string) {
    this.props.name = name
  }

  set weight(weight: number) {
    this.props.weight = weight
  }

  set weightUnit(weightUnit: WeightUnit) {
    this.props.weightUnit = weightUnit
  }

  set stationType(stationType: 'seat' | 'cargo') {
    this.props.stationType = stationType
  }

  set createdAt(createdAt: Date) {
    this.props.createdAt = createdAt
  }

  set updatedAt(updatedAt: Date) {
    this.props.updatedAt = updatedAt
  }

  set deletedAt(deletedAt: Date | undefined) {
    this.props.deletedAt = deletedAt
  }

  public toPojo(): DefaultWeightPojo {
    return {
      id: this.id.toString(),
      name: this.name,
      weight: this.weight,
      weightUnit: this.weightUnit,
      stationType: this.stationType,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      deletedAt: this.deletedAt
    }
  }

  public static fromPojo(pojo: DefaultWeightPojo): DefaultWeight {
    return new DefaultWeight(
      {
        name: pojo.name,
        weight: pojo.weight,
        weightUnit: pojo.weightUnit,
        stationType: pojo.stationType,
        createdAt: pojo.createdAt,
        updatedAt: pojo.updatedAt,
        deletedAt: pojo.deletedAt
      },
      new UniqueEntityID(pojo.id)
    )
  }
}
